import { render, staticRenderFns } from "./DeliverableDetail.vue?vue&type=template&id=094c0bd4&scoped=true&"
import script from "./DeliverableDetail.vue?vue&type=script&lang=js&"
export * from "./DeliverableDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeliverableDetail.vue?vue&type=style&index=0&id=094c0bd4&scoped=true&lang=scss&"
import style1 from "./DeliverableDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094c0bd4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VMenu,VProgressCircular,VSelect})
